<template>
  <div class="mlist-container" v-on:scroll="onscroll" ref="container">
    <div class="mlist-contains" ref="contains">
      <table>
        <thead>
          <slot name="ths"></slot>
        </thead>
        <tbody>
          <tr
            v-for="(item,indexItem) in items"
            :key="item[itemValue]"
            :class="{active:(current==item[itemValue]), 'mlist-item':true}"
            :style="`height:${itemHeight2}px;`"
            @click="onitemclick(item,indexItem,$event)"
          >
            <slot name="tds" :item="item"></slot>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "mlist",
  props: {
    items: {
      default: function() {
        return [];
      },
      type: Array
    },
    current: {
      default: "",
      type: [String, Number]
    },
    itemValue: {
      default: "",
      type: String
    },
    dynamic: {
      default: false,
      type: Boolean
    },
    limit: {
      default: 100,
      type: Number
    },
    total: {
      default: 0,
      type: Number
    },
    skip: {
      default: 0,
      type: Number
    },
    itemHeight: {
      default: 30,
      type: Number
    }
  },
  mounted() {
    this.update();
  },
  data() {
    return {
      scrollTop: 0,
      // skip: 0,
      timerScroll: null
    };
  },
  watch: {
    items(val) {
      // console.log("val", val);
    },
    total(val) {
      // this.calcPadding();
    }
  },
  computed: {
    itemHeight2() {
      return this.itemHeight - 0;
    }
  },
  components: {},
  methods: {
    update() {
      if (!this.dynamic) {
        this.$refs.contains.style.paddingTop = "0px";
        this.$refs.contains.style.paddingBottom = "0px";
        return;
      }
      this.$nextTick(() => {
        let t = 0,
          b = 0;
        //hContainer = this.$refs.container.offsetHeight
        //   console.log("hContainer", hContainer, this.total, this.items.length);
        t = this.skip * this.itemHeight;
        b =
          this.total * this.itemHeight -
          t -
          this.items.length * this.itemHeight;
        if (b < 0) b = 0;
        this.$refs.contains.style.paddingTop = t + "px";
        this.$refs.contains.style.paddingBottom = b + "px";
      });
    },
    scrollToTop() {
      this.$refs.container.scrollTop = 0;
    },
    onscroll(evt, arg2) {
      // console.log("evt", evt.target.scrollTop);
      if (this.timerScroll) window.clearTimeout(this.timerScroll);
      this.timerScroll = window.setTimeout(() => {
        this.scrollTop = evt.target.scrollTop;
        let skip = Math.floor(this.scrollTop / this.itemHeight);
        this.$emit("changerange", skip);
      }, 100);
    },
    onitemclick(item, indexItem, evt) {
      this.$emit("itemclick", item, indexItem, evt);
    }
  }
};
</script>

<style lang="scss">
@import "../sass/variables.scss";
.mlist-container {
  height: 100%;
  overflow: auto;
  .mlist-contains {
    padding: 0;
    table {
      width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      table-layout: fixed;
      tr {
        &:hover {
          background-color: $gris;
        }
        &.active {
          background-color: $bleu-clair;
          td {
            color: $bleu-fonce;
            i {
              color: $bleu-fonce;
            }
          }
        }
        td,
        th {
          padding: 0 10px;
          margin: 0;
          cursor: pointer;
          box-sizing: border-box;
          //  -moz-box-sizing: border-box;
          //  -webkit-box-sizing: border-box;
          border-bottom: 1px solid rgba(0, 0, 0, 0.12);
          font-size: 0.813rem;
          line-height: 0.813rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.75rem;
          text-align: left;
        }
      }
    }
  }
  .mlist-item {
  }
}
</style>